import { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Button } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
// pm2 start npm --name support -- start
dayjs.extend(utc);
dayjs.extend(timezone);
// dayjs.tz.setDefault("Europe/Berlin");
export const formatDateBerlin = (isoStr) => dayjs(isoStr).format('DD.MM.YYYY HH:mm:ss');
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clickQty: 0
        }
    }
    render() {
        return (
            <div className="App">
                <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <p>
                        Edit <code>src/App.js</code> and save to reload.
                    </p>
                    <a
                        className="App-link"
                        href="https://reactjs.org"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        You've clicked {this.state.clickQty} times the button...
                    </a>
                    <div style={{ flexDirection: "row" }}>
                        <Button onClick={() => { this.setState({ clickQty: this.state.clickQty - 1 }) }} variant='contained'> -</Button>
                        <Button onClick={() => { this.setState({ clickQty: this.state.clickQty + 1 }) }} variant='contained'> + </Button>
                    </div>
                </header>
            </div>
        );
    }
}

export default App;
